import { render, staticRenderFns } from "./LogbookCreate.vue?vue&type=template&id=f3344dae&scoped=true"
import script from "./LogbookCreate.vue?vue&type=script&lang=js"
export * from "./LogbookCreate.vue?vue&type=script&lang=js"
import style0 from "./LogbookCreate.vue?vue&type=style&index=0&id=f3344dae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3344dae",
  null
  
)

export default component.exports